import Achievment from './Achievment';
import MyCollection from './MyCollection';
import UpperGreenpillSection from './UpperGreenpillSection';
import achievmentVariant from '../../assets/icons/achievmentVariant.svg';
import { useNavigate } from 'react-router-dom';
import { getAchievments } from '../../apis/geenpills/apis';
import { useLoadingState } from '../../hooks/useLoader';
import { useEffect, useState } from 'react';
import Loader from '../../ui/Loader';

const GreenpillHomePage = () => {
    const navigate = useNavigate();
    const { loading, startLoading, stopLoading } = useLoadingState();
    const [impactsAchieved, setImpactsAchieved] = useState(0);
    useEffect(function () {
        const fetchData = async () => {
            try {
                startLoading();
                const data = await getAchievments();

                const dataMapped = data?.flatMap((a) => {
                    if (a.activityType === 'GROW_ORGANISATION') {
                        return a?.milestones.filter((x) => x > 1);
                    } else {
                        return a?.milestones;
                    }
                });

                setImpactsAchieved(dataMapped?.length);
            } catch (error) {
                console.log(error);
            } finally {
                stopLoading();
            }
        };
        fetchData();
    }, []);

    return (
        <div className="p-9 pb-32">
            <div className={` w-full`}>
                <div className="   h-full  ">
                    <UpperGreenpillSection />
                </div>
                {loading ? (
                    <div className=" w-full justify-center bg-link-gradient px-4 py-[.625rem] rounded-[.25rem] mt-5 flex items-center gap-3 cursor-pointer">
                        <Loader w="w-6" h="h-6" fillColor="fill-[#326F58]" />
                    </div>
                ) : impactsAchieved ? (
                    <div
                        onClick={() => navigate('/profile/gallery')}
                        className="bg-link-gradient px-4 py-[.625rem]  rounded-[.25rem] mt-5 flex items-center gap-3 cursor-pointer "
                    >
                        <>
                            {' '}
                            <img className="w-6 h-6" src={achievmentVariant} alt="achievment-variant" />
                            <p className="font-medium text-textPillGreen">
                                You have {impactsAchieved} {impactsAchieved === 1 ? 'Achievement!' : 'Achievments!'}{' '}
                                Click here to view all of them →
                            </p>
                        </>
                    </div>
                ) : null}
                {/* <Achievment /> */}
            </div>
        </div>
    );
};

export default GreenpillHomePage;
